import Store from 'pages/store';
import './App.scss';
import NavBar from 'components/navbar/navbar';
import Cart from 'pages/cart';
import Authenticate from 'pages/authenticate';
import { Route, Routes } from 'react-router-dom';
import { useAuthState } from 'react-firebase-hooks/auth';
import { fetchUserData, fetchProducts } from 'utils/firebaseFunctions';
import { useEffect, useState, useCallback } from 'react';
import { MainContext } from 'utils/context';
import { setupDBListener } from 'utils/firebaseFunctions';
import { auth } from 'utils/firebaseConfig';
import AddProducts from 'pages/add-products';

function App() {
  const [user, loading] = useAuthState(auth);
  const [username, setUsername] = useState();
  const [cartProducts, setCartProducts] = useState();
  const [isAdmin, setIsAdmin] = useState();
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [products, setProducts] = useState([]);

  const fetchProductsFromDB = useCallback(async () => {
    const res1 = await fetchProducts();
    if (res1.success) {
      setProducts(res1.data);
    }
  }, []);

  const fetchData = useCallback(async () => {
    await fetchProductsFromDB();
    if (user) {
      const res2 = await fetchUserData(user);
      if (res2.success) {
        setUsername(res2.data.username);
        setCartProducts(res2.data.cartProducts);
        setIsAdmin(res2.data.isAdmin);
      }
    }
  }, [user, fetchProductsFromDB]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    if (!loading && user && products.length > 0) {
      setupDBListener(user, (data) => {
        setCartProducts(data);
        setFilteredProducts(products);
      });
    }
  }, [loading, user, products]);

  return (
    <>
      <MainContext.Provider
        value={{
          user,
          loading,
          username,
          cartProducts,
          filteredProducts,
          isAdmin,
          products,
        }}>
        <NavBar />
        <Routes>
          <Route path="/" element={<Store />}></Route>
          <Route path="/cart" element={<Cart />}></Route>
          <Route path="/authenticate" element={<Authenticate />}></Route>
          <Route path="/add-products" element={<AddProducts />}></Route>
        </Routes>
      </MainContext.Provider>
    </>
  );
}

export default App;
